var Option = function Option() {
  return null;
};

export default Option;


//////////////////
// WEBPACK FOOTER
// ../~/rc-mentions/es/Option.js
// module id = 1976
// module chunks = 1